module.exports = __webpack_public_path__ + "img/main_bt_anipang4.ea444728.png";